<template>
  <div>
    <success :success="success"/>

    <form @submit.prevent="register" v-if="!success">

      <login-card header-color="green">
        <h4 slot="title" class="card-title">Регистрация</h4>

        <error slot="description" :errors="errors"/>

        <md-field class="md-form-group" slot="inputs" v-for="(input, key) in auth" :key="key">
          <md-icon>{{ input.icon }}</md-icon>
          <label>{{ input.label }}</label>
          <md-input v-model="input.value" :type="input.type"></md-input>
        </md-field>

        <md-button slot="footer" class="md-simple md-success md-lg" @click="$emit('changeForm')">
          Вход
        </md-button>

        <md-button slot="footer" class="md-simple md-success md-lg" type="submit">
          Ок
        </md-button>

      </login-card>
    </form>
  </div>
</template>

<script>
import Error from "./Error"
import {mapActions} from "vuex"
import { LoginCard } from "@/components"
import Success from "./Success";

export default {
  name: "Login",
  components: {Success, Error, LoginCard},
  data(){
    return {
      auth: {
        name: {
          label: 'Фамилия, Имя',
          value: '',
          type: 'text',
          icon: 'face',
        },
        email: {
          label: 'Email адресс',
          value: '',
          type: 'email',
          icon: 'alternate_email',
        },
        city: {
          label: 'Город',
          value: '',
          type: 'text',
          icon: 'place',
        },
        address: {
          label: 'Название торговой точки',
          value: '',
          type: 'text',
          icon: 'store',
        },
        phone: {
          label: 'Номер телефона',
          value: '',
          type: 'phone',
          icon: 'phone',
        },
        login: {
          label: 'Логин для входа в систему',
          value: '',
          type: 'text',
          icon: 'account_circle',
        },
        password: {
          label: 'Пароль',
          value: '',
          type: 'password',
          icon: 'password',
        },
        password_confirmation: {
          label: 'Повторите пароль',
          value: '',
          type: 'password',
          icon: 'account_circle',
        }
      },
      errors: null,
      success: null
    }
  },
  methods: {
    ...mapActions(["auth/register"]),
    register: function () {
      let data = {
        name: this.auth.name.value,
        email: this.auth.email.value,
        password: this.auth.password.value,
        password_confirmation: this.auth.password_confirmation.value,
        city: this.auth.city.value,
        address: this.auth.address.value,
        phone: this.auth.phone.value,
        login: this.auth.login.value
      }
      this.$store.dispatch('auth/register', data)
          .then((response) => {
            this.errors = [];
            this.success = response;
          })
          .catch(err => {
            this.errors = [];
            if(err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else this.errors = err
          })
    }
  }
}
</script>